export default "__VITE_ASSET__BTuQdxOl__"